export default "__VITE_ASSET__BbY3DjtZ__"